<template>
  <div v-if="loading" class="space-y-2.5 short:space-y-2" aria-busy="true" role="status">
    <span class="sr-only">{{ t('planner.pricing_loading') }}</span>
    <div v-for="n in 2" :key="n" class="h-[78px] animate-pulse rounded-2xl border-2 border-gray-200 bg-gray-100 dark:border-white/10 dark:bg-white/[0.06] short:h-[68px]"/>
  </div>
  <div
      v-else-if="failed"
      class="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50/90 p-4 dark:border-amber-500/40 dark:bg-amber-950/30"
      role="alert"
  >
    <AlertTriangle class="mt-0.5 h-4.5 w-4.5 shrink-0 text-amber-600 dark:text-amber-400"/>
    <div class="min-w-0 flex-1">
      <p class="text-sm font-medium text-amber-900 dark:text-amber-100">
        {{ t('planner.pricing_unavailable') }}
      </p>
      <button
          class="mt-3 w-full rounded-lg bg-amber-700 py-2.5 text-sm font-semibold text-white transition hover:bg-amber-800 dark:bg-amber-600 dark:hover:bg-amber-500"
          type="button"
          @click="$emit('retry')"
      >
        {{ t('planner.pricing_retry') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { AlertTriangle } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'

defineProps({
  loading: { type: Boolean, default: false },
  failed: { type: Boolean, default: false },
})

defineEmits(['retry'])

const { t } = useI18n()
</script>
